module.exports = __webpack_public_path__ + "static/media/online-doctor-image.31edf987.png";